<template>
	<div>
		<div class="title">选择售卖的类目</div>
		<div class="content">
			<div v-for="(item,index) in categoryList" :key="index">
				<div @click="jump(item)" >
					<div>{{item}}</div>
					<div>></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				categoryList:[],
				industry:''
			}
		},
		created() {
		},
		mounted() {
			this.industry=this.$route.query.industry;
			console.log('ddddddddddddddddd',this.industry)
				this.getCategory()
			
		},
		methods:{
			jump(item){
				this.$router.push({path:"/FoodsLibrary", query:{industry:this.industry,category:item}})
			},
			getCategory() {
				var that=this
				console.log('dddddddddddwwwwww',that.industry)
			    this.$http.post('/wechat/api.food_library/getCategory',{industry:that.industry}).then(response => {
			        if (response && response.body.code== 200) {
			            that.categoryList=response.body.data
						console.log(that.categoryList)
			        }
			    })
			},
		}
	}
</script>

<style scoped="scoped">
	.title{
		width: 100%;
		text-align: center;
		font-size: 0.5rem;
		margin: 0.5rem 0;
	}
	.content{
		width: 90%;
		padding:0 0.2rem;
		margin: 0 auto;
		background-color: #FFFFFF;
		border: 1px solid #F0F0F0;
		border-radius: 0.3rem;
	}
	.content>div>div{
		border-bottom: 1px solid #F0F0F0;
		padding:0.4rem 0.2rem;
		font-size: 0.4rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.content>div>div>div:nth-of-type(2){
		color: #999;
	}
</style>
